export default {
    methods: {
        commonTagFormatter({ type, filterBy, toLower = false }) {
            const { translateOr: tOr } = this;

            const filterText = `${this.$t(`FILTERS.${type}`)}`;

            if (typeof filterBy === 'string') {
                const option = toLower ? filterBy.toLowerCase() : filterBy;

                const value = tOr(`FILTERS.${type}_option_${option}`, filterBy);

                return `${filterText}: ${value}`;
            } else {
                const { level = '', value = '' } = filterBy;

                const selectedLevel = tOr(
                    `FILTERS.${type}_option_${level}`,
                    ''
                );
                const selectedValue = tOr(
                    `FILTERS.${type}_option_${value}`,
                    value
                );

                return `${selectedLevel} ${filterText}: ${selectedValue}`;
            }
        },
    },
};
